import { ThemeId, StoredThemePayload } from './types';
import { DEFAULT_THEME_ID, THEME_MAP } from './themes';

export const THEME_STORAGE_KEY = 'trading-bot-dashboard-theme';
const STORAGE_VERSION = 1;

export function isValidThemeId(id: unknown): id is ThemeId {
  return typeof id === 'string' && Object.prototype.hasOwnProperty.call(THEME_MAP, id);
}

export function loadStoredTheme(): ThemeId {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    if (!raw) {
      return DEFAULT_THEME_ID;
    }
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && 'version' in parsed) {
        if (parsed.version === STORAGE_VERSION && isValidThemeId(parsed.theme)) {
          return parsed.theme;
        }
        return DEFAULT_THEME_ID;
      }
      if (isValidThemeId(parsed)) {
        return parsed;
      }
    } catch {
      // Raw string not valid JSON (e.g. unquoted string)
      if (isValidThemeId(raw)) {
        return raw;
      }
    }
    if (isValidThemeId(raw)) {
      return raw;
    }
    return DEFAULT_THEME_ID;
  } catch {
    return DEFAULT_THEME_ID;
  }
}


export function saveStoredTheme(theme: ThemeId): void {
  try {
    if (!isValidThemeId(theme)) {
      theme = DEFAULT_THEME_ID;
    }
    const payload: StoredThemePayload = {
      version: STORAGE_VERSION,
      theme,
    };
    localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // Gracefully handle private browsing quota/access exceptions
  }
}
